module.exports = __webpack_public_path__ + "static/img/taa_icon_debit.4b5d3c5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/taa_icon_debit.jpeg
// module id = S/TT
// module chunks = 1